import { createContext, useState, useEffect } from "react";
import { INIT_URL } from "../Data/apiEndpoints";

export const AvailabilityContext = createContext();

const ADMIN_TOKEN_KEY = "adminToken";

export const AvailabilityProvider = ({ children }) => {
  const [availability, setAvailability] = useState({});
  const [shipping, setShipping] = useState([]);
  const [loading, setLoading] = useState(true);
  const [maintenance, setMaintenance] = useState(false);
  const [sandbox, setSandbox] = useState(false);

  useEffect(() => {
    const fetchInitData = async () => {
      try {
        // Check URL for admin token, persist in sessionStorage
        const urlParams = new URLSearchParams(window.location.search);
        const tokenFromUrl = urlParams.get("token");
        if (tokenFromUrl) {
          sessionStorage.setItem(ADMIN_TOKEN_KEY, tokenFromUrl);
          // Clean token from URL
          urlParams.delete("token");
          const newUrl = window.location.pathname + (urlParams.toString() ? `?${urlParams}` : "");
          window.history.replaceState(null, "", newUrl);
        }

        const adminToken = sessionStorage.getItem(ADMIN_TOKEN_KEY);
        const url = adminToken ? `${INIT_URL}?token=${encodeURIComponent(adminToken)}` : INIT_URL;

        const response = await fetch(url);
        if (response.ok) {
          const data = await response.json();
          if (data.maintenance) {
            setMaintenance(true);
          } else {
            setAvailability(data.products || {});
            setShipping(data.shipping || []);
            if (data.sandbox) setSandbox(true);
          }
        }
      } catch (error) {
        console.error("error fetching init data:", error);
      } finally {
        setLoading(false);
      }
    };

    const trackVisit = async () => {
      if (sessionStorage.getItem("visited")) return;
      // Skip bots and headless browsers
      if (navigator.webdriver) return;
      // Skip tracking when returning from PayPal redirect
      const params = new URLSearchParams(window.location.search);
      if (params.has("success")) {
        sessionStorage.setItem("visited", "true");
        return;
      }
      sessionStorage.setItem("visited", "true");
      try {
        await fetch(INIT_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ referrer: document.referrer || null }),
        });
      } catch {
        // silent — tracking is non-critical
      }
    };

    fetchInitData();
    trackVisit();
  }, []);

  return (
    <AvailabilityContext.Provider value={{ availability, shipping, loading, maintenance, sandbox }}>
      {children}
    </AvailabilityContext.Provider>
  );
};
